import { link } from "fs";
import { Home, MessageCircle, User } from "lucide-react";
import { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";

const navItems = [
  { icon: Home, label: "Home", link: "/app/home" },
  { icon: MessageCircle, label: "Chats", link: "/app/matches" },
  { icon: User, label: "Profile", link: "/app/profile" },
];

export function BottomNav() {
  const location = useLocation();
  let navigate = useNavigate();
  return (
    <nav className="fixed bottom-0 left-0 right-0 bg-gray-800 border-t border-gray-700">
      <ul className="flex justify-around">
        {navItems.map(({ icon: Icon, label, link }) => (
          <li key={label} className="flex-1">
            <button
              onClick={() => (navigate(link), window.scrollTo(0, 0))}
              className={`w-full py-4 flex flex-col items-center justify-center ${
                location.pathname.startsWith(link)
                  ? "text-pink-500"
                  : "text-gray-400"
              }`}
            >
              <Icon className="h-6 w-6" />
              <span className="text-xs mt-1">{label}</span>
            </button>
          </li>
        ))}
      </ul>
    </nav>
  );
}
